import React from "react";

export const renderSinglePlusMore = (
  value: { id: string | number; name: string }[],
  getTagProps: (params: { index: number }) => Record<string, unknown>,
): React.ReactNode => {
  if (!value?.length) return null;

  const first = value[0];
  const more = value.length - 1;

  const tagProps = getTagProps({ index: 0 });

  // Manually remove `key` and `onDelete` before spreading
  const cleanedTagProps = Object.fromEntries(
    Object.entries(tagProps).filter(
      ([key]) => key !== "key" && key !== "onDelete",
    ),
  );

  return [
    <span
      key={first.id}
      {...cleanedTagProps}
      style={{
        display: "inline-block",
        backgroundColor: "#444",
        color: "white",
        borderRadius: "16px",
        padding: "4px 8px",
        marginRight: "4px",
        fontSize: "0.75rem",
        lineHeight: "1",
        border: "1px solid #777",
        maxWidth: "120px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {first.name}
    </span>,

    more > 0 && (
      <span
        key="more"
        style={{
          display: "inline-block",
          backgroundColor: "#2a2736",
          color: "#B8F890",
          borderRadius: "16px",
          padding: "4px 6px",
          fontSize: "0.75rem",
          lineHeight: "1",
          border: "1px dashed #777",
          maxWidth: "60px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        +{more} more
      </span>
    ),
  ];
};
